import React from 'react';
import { PHONE_FRAME_WIDTH, PHONE_FRAME_HEIGHT } from '../constants';

const MobileFrame = ({ scale, children }) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <div 
        className="relative"
        style={{
          transform: `scale(${scale})`,
          transformOrigin: 'center'
        }}
      >
        {/* Phone frame */}
        <div 
          className="relative bg-neutral-900 dark:bg-neutral-800 rounded-[3rem] p-3 shadow-2xl"
          style={{
            width: `${PHONE_FRAME_WIDTH}px`,
            height: `${PHONE_FRAME_HEIGHT}px`
          }}
        >
          {/* Screen bezel */}
          <div className="relative w-full h-full bg-black rounded-[2.5rem] overflow-hidden">
            {/* Iframe placeholder area */}
            <div className="absolute inset-0" style={{ pointerEvents: 'auto' }}>
              {children}
            </div>
            
            {/* Home indicator */}
            <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-neutral-300 dark:bg-neutral-700 rounded-full" />
          </div>
          
          {/* Side buttons */}
          <div className="absolute -left-1 top-24 w-1 h-12 bg-neutral-800 dark:bg-neutral-700 rounded-l" />
          <div className="absolute -left-1 top-40 w-1 h-20 bg-neutral-800 dark:bg-neutral-700 rounded-l" />
          <div className="absolute -left-1 top-64 w-1 h-20 bg-neutral-800 dark:bg-neutral-700 rounded-l" />
          <div className="absolute -right-1 top-44 w-1 h-16 bg-neutral-800 dark:bg-neutral-700 rounded-r" />
        </div>
      </div>
    </div>
  );
};

export default MobileFrame; 